import { render } from "./MessageScreen.vue?vue&type=template&id=f3e0ea5e"
import script from "./MessageScreen.vue?vue&type=script&lang=js"
export * from "./MessageScreen.vue?vue&type=script&lang=js"

import "./MessageScreen.vue?vue&type=style&index=0&id=f3e0ea5e&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__